(function () {
    'use strict';

    angular
        .module('adminControllers', ['services.authenticatedUser']);
})();
